const comments = [
  {
    name: '吃瓜小能手',
    time: '2小时前',
    text: '我每天必刷爆瓜网！更新速度真的太快了，每次朋友群里发的八卦我都是第一个知道的，已经推荐给所有同事了。',
    likes: '1.2k',
  },
  {
    name: '娱乐观察家',
    time: '5小时前',
    text: '内容质量真的高，不像其他平台全是标题党。爆瓜网的编辑团队水平在线，深度专题也做得很专业，追了好几年了。',
    likes: '986',
  },
  {
    name: '夜猫子不睡觉',
    time: '8小时前',
    text: '深夜档的福利！好几次半夜刷到独家爆料，第二天全网才跟上。收藏了官网入口，再也不怕迷路了。',
    likes: '743',
  },
  {
    name: '追星少女日常',
    time: '12小时前',
    text: '作为资深追星人，爆瓜网的信息覆盖面真的没得说。从顶流到新人，从影视到音乐，一个站全部搞定。',
    likes: '621',
  },
  {
    name: '办公室八卦王',
    time: '1天前',
    text: '午休时间在公司打开爆瓜网已经成为固定节目了，同事们围过来一起看的画面太美。感谢爆瓜网提供的快乐源泉！',
    likes: '508',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-50">
      <div className="mx-auto px-4 md:px-6 max-w-7xl">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-10">
          瓜友热评
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {comments.slice(0, 2).map((c, i) => (
            <div key={i} className="lg:col-span-1 bg-background-100 rounded-xl p-5">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-heading text-primary-600">{c.name[0]}</span>
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-900">{c.name}</div>
                  <div className="text-xs text-foreground-500">{c.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">{c.text}</p>
              <div className="flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-thumb-up-line"></i>
                <span>{c.likes}</span>
              </div>
            </div>
          ))}
          {comments.slice(2).map((c, i) => (
            <div key={i + 2} className="bg-background-100 rounded-xl p-5">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-heading text-accent-600">{c.name[0]}</span>
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-900">{c.name}</div>
                  <div className="text-xs text-foreground-500">{c.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">{c.text}</p>
              <div className="flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-thumb-up-line"></i>
                <span>{c.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}